import axios from "axios";
import { api, headers } from "../../app/conf";
import { makeQuery } from "../../shared/helpers/commons";

export const unsubscribeService = (token, formData) => {
    return axios({
        method: 'put',
        url: `${api}/gps/deregister`,
        headers: {
            "X-Access-Token": token
        },
        data: formData
    });
};

export const disassociatesimcard = (id, token) =>
axios({
    method:"put",
    url: `${api}/gps/disassociations/${id}`,
    headers: {
        ...headers,
        "X-Access-Token": token
    }
});

export const getGpsDevices = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/gps?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });

export const getGpsStatuses = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/gps/statuses?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });
export const getGpsSubstatus = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/gps/substatus?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });
    
export const getHistoryGps = (id, token) =>
    axios({
        method: "get",
        url: `${api}/gps/history/${id}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });
    
export const postGpsDevice = (gps_device, token) =>
    axios({
        method: "post",
        url: `${api}/gps`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: gps_device
    });

export const postGpsDeviceBatch = (gps_devices, token) =>
    axios({
        method: "post",
        url: `${api}/gps/batch`,
        headers: {
            "Content-Type": "application/json",
            "X-Access-Token": token
        },
        data: gps_devices
    });

export const getValidateBatchGpsDevices = (device, token) =>
    axios({
        method: "post",
        url: `${api}/gps/batch/validations`,
        headers: {
            "Content-Type": "form-urlencoded",
            "X-Access-Token": token
        },
        data: device
    });

    export const putGpsDevice = (id, data, token) =>
        axios({
          method: "put",
          url: `${api}/gps/${id}`,
          headers: {
            ...headers,
            "X-Access-Token": token
          },
          data
        });
      

    export const patchGpsDevices = (gpsDevicesArray, token) => {
        return axios({
            method: 'patch',
            url: `${api}/gps/batch`,
            headers: {
                ...headers,
                'Content-Type': 'application/json',
                'x-access-token': token
            },
            data: gpsDevicesArray
        });
    };

export const postGpsStatuses = (status, token) =>
    axios({
        method: "post",
        url: `${api}/gps/statuses`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: status
    });

export const putGpsStatuses = (status, token) =>
    axios({
        method: "put",
        url: `${api}/gps/statuses/${status._id}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        data: status
    });

export const getExportGpsService = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/gps/export?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        },
        responseType: 'blob'
    });